const corporateBrochure = {
  // page.tsx
  'corporateBrochure.page.lastUpdated': '最終更新: 2026年7月5日',
  'corporateBrochure.page.backToTop': 'ページトップへ戻る',
  'corporateBrochure.page.homeLink': 'ホーム',
  'corporateBrochure.page.corporateLink': '法人研修',
  'corporateBrochure.page.currentPage': '法人資料請求',

  // JSON-LD
  'corporateBrochure.jsonld.serviceName': '法人向け出張型研修 案内資料請求',
  'corporateBrochure.jsonld.orgName': '一般社団法人全日本執事協会',
  'corporateBrochure.jsonld.serviceType': '企業向け接遇研修の案内資料請求',
  'corporateBrochure.jsonld.areaServed': '日本',
  'corporateBrochure.jsonld.description': '出張型・来校型の法人研修プログラム、料金、実施の流れをまとめた法人向け案内資料の請求ページ。',
  'corporateBrochure.jsonld.breadcrumb1': 'ホーム',
  'corporateBrochure.jsonld.breadcrumb2': '法人研修',
  'corporateBrochure.jsonld.breadcrumb3': '法人資料請求',

  // HeroSection
  'corporateBrochure.hero.homeLink': 'ホーム',
  'corporateBrochure.hero.corporateLink': '法人研修',
  'corporateBrochure.hero.currentPage': '法人資料請求',
  'corporateBrochure.hero.title': '法人向け出張型研修 資料請求',
  'corporateBrochure.hero.titleEn': 'CORPORATE BROCHURE REQUEST',
  'corporateBrochure.hero.lead': '出張型・来校型の法人研修プログラム、料金、実施の流れをまとめた法人向け案内資料をお送りします。フォーム送信後、ご案内メールをお送りします。',
  'corporateBrochure.hero.imgAlt': '企業研修で受講者に接遇の所作を指導する日本人執事講師',

  // Contents
  'corporateBrochure.contents.label': 'DOCUMENT CONTENTS',
  'corporateBrochure.contents.title': '資料の内容',
  'corporateBrochure.contents.subtitleEn': 'What\'s Inside',
  'corporateBrochure.contents.lead': '法人向け案内資料には、以下の内容を収録しています。',
  'corporateBrochure.contents.0.title': '6つの研修モジュール',
  'corporateBrochure.contents.0.titleEn': 'SIX TRAINING MODULES',
  'corporateBrochure.contents.0.desc': '立ち居振る舞い・VIP対応・ティー&テーブルサービスなど6モジュールの詳細',
  'corporateBrochure.contents.1.title': '業種別プログラム例',
  'corporateBrochure.contents.1.titleEn': 'INDUSTRY PROGRAMMES',
  'corporateBrochure.contents.1.desc': 'ホテル・金融・医療など8業種の業種別プログラム例',
  'corporateBrochure.contents.2.title': '料金プラン',
  'corporateBrochure.contents.2.titleEn': 'PRICING PLANS',
  'corporateBrochure.contents.2.desc': '半日・1日・継続プログラムなど料金プランの詳細',
  'corporateBrochure.contents.3.title': '出張実施の流れ',
  'corporateBrochure.contents.3.titleEn': 'ON-SITE DELIVERY FLOW',
  'corporateBrochure.contents.3.desc': 'お問い合わせからヒアリング・出張実施・レポートまでの流れ',
  'corporateBrochure.contents.4.title': '運営団体について',
  'corporateBrochure.contents.4.titleEn': 'ABOUT THE ASSOCIATION',
  'corporateBrochure.contents.4.desc': '日本の執事学校を運営する一般社団法人全日本執事協会と講師陣のご紹介',
  'corporateBrochure.contents.notice': '資料はPDF形式でメールにてお送りします。',

  // Form
  'corporateBrochure.form.label': 'REQUEST FORM',
  'corporateBrochure.form.title': '法人資料請求フォーム',
  'corporateBrochure.form.subtitleEn': 'Corporate Brochure Request',
  'corporateBrochure.form.lead': '以下のフォームに必要事項をご入力のうえ、送信ください。フォーム送信後、ご案内メールをお送りします。',
  'corporateBrochure.form.noHardSell': '資料請求は無料です。ご希望のない方への過度なご連絡はいたしません。安心してお申込みください。',
  'corporateBrochure.form.company': '会社名',
  'corporateBrochure.form.company.placeholder': '例: 株式会社〇〇',
  'corporateBrochure.form.company.error': '会社名は必須です',
  'corporateBrochure.form.department': '部署・役職',
  'corporateBrochure.form.department.placeholder': '例: 人事部 研修担当',
  'corporateBrochure.form.name': 'ご担当者名',
  'corporateBrochure.form.name.placeholder': '例: 執事 太郎',
  'corporateBrochure.form.name.error': 'ご担当者名は必須です',
  'corporateBrochure.form.email': 'メールアドレス',
  'corporateBrochure.form.email.placeholder': '例: taro@example.com',
  'corporateBrochure.form.email.error': 'メールアドレスは必須です',
  'corporateBrochure.form.email.invalid': '有効なメールアドレスを入力してください',
  'corporateBrochure.form.phone': '電話番号',
  'corporateBrochure.form.phone.placeholder': '例: 090-1234-5678',
  'corporateBrochure.form.industry': '業種',
  'corporateBrochure.form.industry.error': '業種をお選びください',
  'corporateBrochure.form.industry.select': '選択してください',
  'corporateBrochure.form.industry.hotel': 'ホテル・旅館',
  'corporateBrochure.form.industry.residence': '高級レジデンス',
  'corporateBrochure.form.industry.finance': '金融',
  'corporateBrochure.form.industry.retail': '百貨店・小売',
  'corporateBrochure.form.industry.luxurySales': 'ラグジュアリー営業',
  'corporateBrochure.form.industry.clinic': '医療・クリニック',
  'corporateBrochure.form.industry.automotive': '自動車・モビリティ',
  'corporateBrochure.form.industry.chauffeur': 'ハイヤー・送迎',
  'corporateBrochure.form.industry.other': 'その他',
  'corporateBrochure.form.participants': '対象人数',
  'corporateBrochure.form.participants.placeholder': '例: 10名',
  'corporateBrochure.form.format': '希望形式',
  'corporateBrochure.form.format.select': '選択してください',
  'corporateBrochure.form.format.dispatch': '出張',
  'corporateBrochure.form.format.onsite': '来校',
  'corporateBrochure.form.format.undecided': '未定',
  'corporateBrochure.form.timeline': '検討時期',
  'corporateBrochure.form.timeline.placeholder': '例: 来月、今期中、未定',
  'corporateBrochure.form.message': 'ご要望（任意）',
  'corporateBrochure.form.message.placeholder': '研修の目的やご要望、ご不明な点など、自由にご記入ください。',
  'corporateBrochure.form.message.error': '500文字以内で入力してください',
  'corporateBrochure.form.required': '必須',
  'corporateBrochure.form.optional': '任意',
  'corporateBrochure.form.privacyAgree': '内容に同意のうえ送信します',
  'corporateBrochure.form.privacy': 'プライバシーポリシー',
  'corporateBrochure.form.privacyError': 'プライバシーポリシーへの同意が必要です',
  'corporateBrochure.form.submit': 'この内容を確認する',

  // Confirm page
  'corporateBrochure.confirm.homeLink': 'ホーム',
  'corporateBrochure.confirm.corporateLink': '法人研修',
  'corporateBrochure.confirm.brochureLink': '法人資料請求',
  'corporateBrochure.confirm.currentPage': '確認',
  'corporateBrochure.confirm.title': '法人資料請求内容の確認',
  'corporateBrochure.confirm.lead': '以下の内容でお間違いなければ、「送信する」をクリックしてください。',
  'corporateBrochure.confirm.edit': '修正する',
  'corporateBrochure.confirm.submit': '送信する',
  'corporateBrochure.confirm.submitting': '送信中...',
  'corporateBrochure.confirm.error': '送信に失敗しました。お手数ですが、再度お試しいただくか、お電話（03-6824-4086）にてお申込みください。',
  'corporateBrochure.confirm.networkError': '通信エラーが発生しました。ネットワーク接続をご確認のうえ、再度お試しください。',
  'corporateBrochure.confirm.field.company': '会社名',
  'corporateBrochure.confirm.field.department': '部署・役職',
  'corporateBrochure.confirm.field.name': 'ご担当者名',
  'corporateBrochure.confirm.field.email': 'メールアドレス',
  'corporateBrochure.confirm.field.phone': '電話番号',
  'corporateBrochure.confirm.field.industry': '業種',
  'corporateBrochure.confirm.field.format': '希望形式',
  'corporateBrochure.confirm.field.participants': '対象人数',
  'corporateBrochure.confirm.field.timeline': '検討時期',
  'corporateBrochure.confirm.field.message': 'ご要望',
  'corporateBrochure.confirm.field.privacy': 'プライバシーポリシー',
  'corporateBrochure.confirm.unspecified': '（未入力）',
  'corporateBrochure.confirm.agreed': '同意済み',

  // Complete page
  'corporateBrochure.complete.title': 'お申込みありがとうございます',
  'corporateBrochure.complete.lead1': 'ご入力いただいたメールアドレスに、受付確認の自動返信メールをお送りしました。',
  'corporateBrochure.complete.lead2': '法人向け案内資料はメールにてお送りします。ご不明な点がございましたら、お電話（03-6824-4086・平日10:00〜17:00）にてお気軽にお問い合わせください。',
  'corporateBrochure.complete.corporateBtn': '法人研修ページへ',
  'corporateBrochure.complete.homeBtn': 'トップページへ',

  // FAQSection
  'corporateBrochure.faq.label': 'FAQ',
  'corporateBrochure.faq.title': 'よくあるご質問',
  'corporateBrochure.faq.subtitleEn': 'Frequently Asked Questions',
  'corporateBrochure.faq.0.q': '資料はどのような形式で届きますか？',
  'corporateBrochure.faq.0.a': 'PDF形式でメールにお送りします。',
  'corporateBrochure.faq.1.q': '資料請求だけで営業の電話はかかってきませんか？',
  'corporateBrochure.faq.1.a': '資料請求は無料で、ご希望のない方への過度なご連絡はいたしません。ご質問がある場合はお気軽にお問い合わせください。',
  'corporateBrochure.faq.2.q': '個人向けの資料請求とは違うのですか？',
  'corporateBrochure.faq.2.a': 'はい、こちらは法人向け出張型研修専用の案内資料です。執事・バトラー育成コースの資料をご希望の場合は個人向け資料請求ページをご利用ください。',

  // RelatedPages
  'corporateBrochure.related.label': 'RELATED',
  'corporateBrochure.related.title': '関連ページ',
  'corporateBrochure.related.subtitleEn': 'See Also',
  'corporateBrochure.related.viewMore': '詳しく見る',
  'corporateBrochure.related.0.title': '法人研修について',
  'corporateBrochure.related.0.desc': '出張型・来校型の研修プログラム全体像と料金',
  'corporateBrochure.related.1.title': '個人向け資料請求',
  'corporateBrochure.related.1.desc': '執事・バトラー育成コースの資料はこちら',
  'corporateBrochure.related.2.title': 'お問い合わせ',
  'corporateBrochure.related.2.desc': 'お電話・メールでのお問い合わせ',
  'corporateBrochure.related.3.title': '個別相談',
  'corporateBrochure.related.3.desc': 'オンラインでの個別相談予約',

  // CTASection
  'corporateBrochure.cta.lead': '資料を見ながら詳しくご相談されたい場合は、法人研修ページまたはお問い合わせからご連絡ください。',
  'corporateBrochure.cta.corporateBtn': '法人研修ページへ',
  'corporateBrochure.cta.contactBtn': 'お問い合わせ',
};

export default corporateBrochure;
